// extracted by mini-css-extract-plugin
export default {"app":"App_app__kjqwC","footer":"App_footer__FwuVS"};